<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">

      <el-row :gutter="10">
        <el-col :md="8" :lg="6">
          <el-input placeholder="订单号" v-model="orderNo" size="mini"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
        </el-col>
        <el-col :md="10" :lg="8">
            <el-date-picker v-model="timeRange" type="daterange" start-placeholder="开始时间" ange-separator="至" end-placeholder="结束时间" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
        </el-col>
        </el-row>
        <el-row :gutter="8">
        <div class="btn-2"></div>
        <el-col :md="8" :lg="6">
          <el-button size="mini" type="primary" @click="exportData">导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-tabs type="border-card" @tab-click="handleClick">
        <el-table :data="list" style="width: 100%" :height="wheight-200" v-loading="loading">
          <el-table-column prop="orderNo" width="160" label="订单号"></el-table-column>
          <el-table-column prop="serviceName" label="服务名"></el-table-column>
          <el-table-column prop="nursingIoCation" label="症状描述"></el-table-column>
          <el-table-column prop="name" label="患者姓名"></el-table-column>
          <el-table-column prop="address" label="地址信息"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="payTime" label="支付时间"></el-table-column>
          <el-table-column prop="zfje" label="支付金额"></el-table-column>
          <el-table-column prop="surcharge" label="附加费用"></el-table-column>
          <el-table-column prop="surpayTime" label="附加费支付时间"></el-table-column>
          <el-table-column prop="orderState" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.orderState == 0" size="mini">0待支付</el-tag>
              <el-tag v-else-if="scope.row.orderState == 1" type="danger" size="mini">待接单</el-tag>
              <el-tag v-else-if="scope.row.orderState == 2" type="success" size="mini">无人接单</el-tag>
              <el-tag v-else-if="scope.row.orderState == 3" type="warning" size="mini">确认医嘱</el-tag>
              <el-tag v-else-if="scope.row.orderState == 4" type="warning" size="mini">已接单</el-tag>
              <el-tag v-else-if="scope.row.orderState == 5" type="warning" size="mini">待评价</el-tag>
              <el-tag v-else-if="scope.row.orderState == 6" type="warning" size="mini">已完成</el-tag>
              <el-tag v-else-if="scope.row.orderState == 7" type="warning" size="mini">申请撤销</el-tag>
              <el-tag v-else-if="scope.row.orderState == 8" type="warning" size="mini">已撤销</el-tag>
              <el-tag v-else-if="scope.row.orderState == 9" type="warning" size="mini">已取消</el-tag>
              <el-tag v-else-if="scope.row.orderState == 10" type="warning" size="mini">已失效</el-tag>
              <el-tag v-else>1</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div>
                  <el-button size="mini" type="primary" @click="dialogOpen(scope.row.orderNo,scope.row.orderState)">查询状态</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="params.page"
            :page-sizes="[10,20,50]"
            :total="total_count"
            :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tabs>
    </div>
    <router-view></router-view>
    <!-- <el-dialog title="备注" :visible.sync="canceldialog" :close-on-click-modal="false" width="50%">
      <section class="section section-white content-padded" onload="init()">
        <h2 class="delog-h2">状态：{{massage}}</h2>
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="回复顾客前后台可见" prop="source_video_type">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入要回复的内容"
              v-model="form.home_msg">
            </el-input>
          </el-form-item>

          <el-form-item label="新增备注进后台可见" prop="source_video_type">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注内容"
              v-model="form.admin_msg">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer content-center">
          <el-button @click.native="canceldialog = false;">取消</el-button>
          <el-button type="primary" @click="addPostMsg()">确认提交</el-button>
        </div>
      </section>
      <el-tabs type="border-card">
        <el-tab-pane label="管理员回复日志（前台只展示最新一条回复内容）" name="0"></el-tab-pane>
        <el-table :data="form_list" style="width: 100%" label="" v-loading="loadingList">
          <el-table-column prop="admin_text" label="信息:">
            <template slot-scope="scope">
              <div v-html="scope.row.home_text"></div>
            </template>
          </el-table-column>
        </el-table>

      </el-tabs>
      <el-tabs type="border-card">
        <el-tab-pane label="管理员备注日志" name="0"></el-tab-pane>
        <el-table :data="form_list" style="width: 100%" label="管理员备注日志" v-loading="loadingList">
          <el-table-column prop="admin_text" label="信息:">
            <template slot-scope="scope">
              <div v-html="scope.row.admin_text"></div>
            </template>
          </el-table-column>
        </el-table>
      </el-tabs>
    </el-dialog> -->
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { getYwmddList, getYwmddExport,getYwmddUpdate,getYwmStatusList} from '../../../api/trade'

  export default {
    components: {
    },
    data () {
      return {
        loading: false,
        loadingList:false,
        canceldialog:false,
        status:0,
        orderNo:'',
        massage:"",
        create_time: '',
        params: {
          page: 1,
          pageSize: 20
        },
        total_count: 0,
        list: [],
        imgs:[],
        mobile:'',
        timeRange:'',
        form:{
          home_msg:'',
          admin_msg:'',
          find_durg_id:0,
          stastu:0,
        },
        form_list:[]
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      // 切换tab
      handleClick(tab, event) {
        this.params.status = tab.name == 0 ? '' : tab.name
        this.params.page = 1
        console.log(this.params)
        this.getList(this.params)
      },

      numberSearch (e) {
        this.params.page = 1
        this.getParams()
        this.params.mobile = this.mobile
        this.getList(this.params)
      },

      handleCurrentChange (val) {
        this.params.page = val
        this.loading = false
        this.getParams()
        this.getList(this.params)
      },
      handleSizeChange (pageSize) {
        this.loading = false
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getParams()
        this.getList(this.params)
      },
      getParams () {

      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
      getList() {
        this.loading = true
        getYwmddList(this.params).then(response => {
          this.list = response.data.data.list
          this.total_count = 'undefined' == typeof (response.data.data.pager) ? response.data.data.total_count : Number(response.data.data.pager.count)
          this.loading = false
        })
      },
      dialogOpen (id,val) {
          var params = {'id': id,'status':val}
          getYwmddUpdate(params).then(response => {
              this.$message({ type: 'success', message: '操作成功'})
              this.getList()

          })
      },
      dateChange (val) {
          if (val && val.length > 0) {
              this.params.start_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_at = ''
              this.params.end_at = ''
          }
          console.log(this.params)
          this.getList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      },
      dialogCancel (detail,status) {
          this.canceldialog = true
          if(status==0)
          {
            this.massage = "待确认"
          }else if(status==1){
            this.massage = "找药中"
          }else{
            this.massage = "结果反馈"
          }
          this.form.status = status
          this.form.find_durg_id = detail
          this.loadingList = true
          getMsgList({status:this.form.status,find_durg_id:this.form.find_durg_id}).then(response => {
            this.form_list = response.data.data
            this.loadingList = false
            console.log(this.form_list)

          })
      },
      exportData() {
        this.exportloading = true
        // this.params.export = 1
        console.log(this.params,'22222222')
        getYwmddExport(this.params).then(res => {
          this.exportloading = false
          console.log(res.data.status)
          if (res.data.status) {
            this.$message({
              type: 'success',
              message: '已加入执行队列，请在设置-导出列表中下载'
            })
            return
          } else if (res.data.data.url) {
            this.downloadUrl = res.data.url
            this.downloadName = res.data.filename
            this.downloadView = true
          } else {
            this.$message({
              type: 'error',
              message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        }).catch(error => {
          this.exportloading = false
        })
      }
    },
    mounted () {
      this.getList()
    }
  }
</script>
<style>
    .btn-2{
       margin: 2rem;
    }
    .delog-h2{
      font-weight: bold;
      color: #5DAF34;
    }
    span.sacss {
        margin-left: 2rem;
    }
</style>



// WEBPACK FOOTER //
// ywmdd.vue?710a58e1